module.exports = "/virtual-football-league/img/amblems/left/logos/BILBAO.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/BILBAO.png
// module id = 2054
// module chunks = 4